import { MuiTelInput } from "mui-tel-input";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import LavorisService from "../../../services/LavorisService";
// import { validAreaCodes } from "./codigoArea";

type TProps = {
    fieldName: string;
    label: string;
    error: any;
    control: any;
    required: boolean;
};

export const PhoneNumber = ({
    fieldName,
    label,
    error,
    control,
    required,
}: TProps) => {
    const LavorisInstance = LavorisService.getInstance();
    const [validAreaCodes, setValidAreaCodes] = useState<string[]>([]);

    const fetchAreaCodes = async () => {
        const areaCodes = await LavorisInstance.AreaCodesService.getAllAreaCodes();
        const codesArray = areaCodes?.items?.map((c: any) => c.code);
        setValidAreaCodes(codesArray);
    };

    useEffect(() => {
        fetchAreaCodes();
    }, []);
    
    return (
        <Controller
            name={fieldName}
            control={control}
            rules={{
                required: required ? "Este campo es requerido" : false,
                validate: (value) => {
                    // Si el número no empieza con +54, no valida nada adicional
                    if (!value.startsWith("+54")) {
                        return true;
                    }

                    // Validar el formato del número argentino
                    const formatRegex = /^\+54 \d{2,4} \d{2,4} \d{4}$/;
                    if (!formatRegex.test(value)) {
                        return "Ingrese un número válido (Ej: +54 11 5021 9043 o +54 341 552 1904)";
                    }

                    // Extraer los componentes del número
                    const parts = value.split(" ");
                    const potentialAreaCode = parts[1]; // Obtiene el área

                    // Validar el código de área
                    const areaCode = validAreaCodes.includes(potentialAreaCode)
                        ? potentialAreaCode
                        : validAreaCodes.includes(potentialAreaCode.slice(0, 3))
                        ? potentialAreaCode.slice(0, 3)
                        : potentialAreaCode;

                    if (!validAreaCodes.includes(areaCode)) {
                        return "El código de área no es válido para Argentina";
                    }

                    return true;
                },
            }}
            render={({ field, fieldState }) => (
                <MuiTelInput
                    {...field}
                    defaultCountry={"AR"}
                    inputProps={{
                        maxLength: 16,
                        minLength: 12,
                    }}
                    required={required}
                    label={label}
                    helperText={Boolean(error) ? error.message : ""}
                    error={Boolean(error)}
                />
            )}
        />
    );
};
